module.exports = __webpack_public_path__ + "static/media/dash_logo.a7c91ae1.png";